import { wrapFunctionalComponent } from 'utils/framework';
import StoreSwitcher from 'components/Header/StoreSwitcher';
import ReserveAndPickUpModal from 'components/GlobalModals/ReserveAndPickUpModal/ReserveAndPickUpModal';
import InventoryAwareStorePickerModal from 'components/GlobalModals/InventoryAwareStorePickerModal';
import { VARIANTS } from 'constants/InventoryAwareStorePicker';

/**
 * StorePickerWrapper - Unified Store Selection Modal
 *
 * This wrapper component hijacks BOTH legacy store picker modal actions and routes them
 * to either the new unified InventoryAwareStorePickerModal or the legacy modals.
 *
 * ## Actions Intercepted:
 *
 * 1. SHOW_STORE_SWITCHER_MODAL
 *    - Triggered from: Header, Upper Funnel filters, Basket
 *    - Legacy component: StoreSwitcher
 *    - Used for: Changing preferred store in header, selecting store for filters
 *
 * 2. SHOW_RESERVE_AND_PICK_UP_MODAL
 *    - Triggered from: Product pages (BOPIS selection), Basket (Change Method)
 *    - Legacy component: ReserveAndPickUpModal
 *    - Used for: Product-specific store selection with inventory awareness
 *
 */

function StorePickerWrapper(props) {
    const { isInventoryAwareStorePickerEnabled, variant, ...restProps } = props;

    if (isInventoryAwareStorePickerEnabled) {
        return (
            <InventoryAwareStorePickerModal
                variant={variant}
                {...restProps}
            />
        );
    } else {
        if (variant === VARIANTS.PRODUCT) {
            return <ReserveAndPickUpModal {...restProps} />;
        }

        return <StoreSwitcher {...restProps} />;
    }
}

export default wrapFunctionalComponent(StorePickerWrapper, 'StorePickerWrapper');
